/**
 * @author Petr Mikušek <petr.mikusek@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @private
 * @typedef {import('./store').default} Store
 * @typedef {import('js-data').DSConfiguration} DSConfiguration
 */

/**
 * @typedef {import('./store').PersistentMap & import('./store').TransientMap} ResourceMap
 */

/**
 * @template {keyof ResourceMap} R
 * @param {Store} store
 * @param {R} resourceName
 * @param {ResourceMap[R][0]} attrs
 * @param {DSConfiguration} [options]
 * @returns {ResourceMap[R][1]}
 */
export function storeInject(store, resourceName, attrs, options) {
  return store.ds.inject(resourceName, attrs, options);
}

/**
 * @deprecated TODO #555, #409: Dočasně jen pro testy AnalyticsCounter a injektování
 * perzistentního datového zdroje AnaylticsCounter.
 * @template {keyof ResourceMap} R
 * @param {Store} store
 * @param {R} resourceName
 * @param {ResourceMap[R][0][]} attrsArray
 * @param {DSConfiguration} [options]
 * @returns {ResourceMap[R][1][]}
 */
export function storeInjects(store, resourceName, attrsArray, options) {
  return store.ds.inject(resourceName, attrsArray, options);
}

/**
 * @template {keyof ResourceMap} R
 * @param {Store} store
 * @param {R} resourceName
 * @param {ResourceMap[R][0]} attrs
 * @param {DSConfiguration} [options]
 * @returns {ResourceMap[R][1]}
 */
export function storeInstance(store, resourceName, attrs, options) {
  return store.ds.createInstance(resourceName, attrs, options);
}

/**
 * @template {keyof ResourceMap} R
 * @param {Store} store
 * @param {R} resourceName
 * @param {ResourceMap[R][0][]} attrsArray
 * @param {DSConfiguration} [options]
 * @returns {ResourceMap[R][1][]}
 */
export function storeInstances(store, resourceName, attrsArray, options) {
  return attrsArray.map((attrs) =>
    storeInstance(store, resourceName, attrs, options)
  );
}
